import { castArray } from '@sama/micro-dash';
import { Object3D } from 'three';

export enum RendererLayer {
  // We intentionally start renderer layers at 1; by default,
  // ThreeJS adds newly-created meshes to layer 0. We don't want
  // newly-added meshes to be visible in *any* renderer unless
  // the caller explicitly specifies layers with `setRendererLayers()`.
  Main = 1,
  SideViewTop,
  SideViewMiddle,
  SideViewBottom,
  Projection,
  Orthographic,
}

export function getAllRendererLayers() {
  return [
    RendererLayer.Main,
    RendererLayer.SideViewTop,
    RendererLayer.SideViewMiddle,
    RendererLayer.SideViewBottom,
    RendererLayer.Projection,
    RendererLayer.Orthographic,
  ];
}

export function getAllRendererLayersExcept(...rendererLayers: RendererLayer[]) {
  return getAllRendererLayers().filter(
    (rendererLayer) => !rendererLayers.includes(rendererLayer),
  );
}

export function getSideViewRendererLayers() {
  return [
    RendererLayer.SideViewBottom,
    RendererLayer.SideViewMiddle,
    RendererLayer.SideViewTop,
  ];
}

export function setRendererLayers(
  layers: RendererLayer[],
  objectOrObjects: Object3D | Object3D[],
) {
  castArray(objectOrObjects).forEach((object3D) => {
    object3D.layers.disableAll();

    layers.forEach((layer) => {
      object3D.layers.enable(layer);
    });

    setRendererLayers(layers, object3D.children);
  });
}
